import { Row } from "antd";
import { useWatch } from "antd/es/form/Form";
import { FormInstance } from "antd/lib/form";
import { useEffect } from "react";
import { NumberInput, TextAreaInput } from "../FormItem/FormItems";

type Props = {
  form: FormInstance<any>;
};

const InvoiceSubTotal = ({ form }: Props) => {
  const billingForm = useWatch(["billing_information"], form);

  const invoice_sub_total = useWatch(["invoice_sub_total"], form);
  const discount: number = useWatch(["invoice_discount"], form);
  const serviceCharge: number = useWatch(["invoice_service_charge"], form);
  const vat: number = useWatch(["invoice_vat"], form);

  useEffect(() => {
    form?.setFieldValue(
      "invoice_net_total",
      (Number(invoice_sub_total) || 0) -
        (Number(discount) || 0) +
        (Number(vat) || 0) +
        (Number(serviceCharge) || 0)
    );
  }, [billingForm, invoice_sub_total, discount, vat, serviceCharge]);

  return (
    <Row gutter={[10, 0]} className="p-5 border">
      <TextAreaInput size={8} label="Note" name="invoice_note" />
      <NumberInput
        size={4}
        label="Sub Total"
        name="invoice_sub_total"
        readOnly
        min="0"
        maxChar={14}
      />
      <NumberInput
        size={4}
        label="Agent Commission"
        name={"invoice_agent_com_amount"}
        min="0"
        maxChar={10}
      />
    </Row>
  );
};

export default InvoiceSubTotal;
